import { OrganizationInfo, UserInfo } from '../types';
import apiRequest from './apiRequest';

export async function getUserInfo() {
  return apiRequest<{
    userInfo: UserInfo;
    organizationInfo: OrganizationInfo;
    clientSlug?: string;
  }>('user', '/users/info');
}
